import React from "react";
import { GRID_ORG_NAME_LINK_CLASS } from "../../utils/gridOrgNameLinks";

/**
 * Org name in a data grid: plain text when not navigable, link styling when href is set.
 */
export default function GridOrgNameLink({
  name,
  href,
  onNavigate,
  className = "",
  fallback = "--",
}) {
  const label = name == null || String(name).trim() === "" ? fallback : name;
  if (label === fallback && (name == null || String(name).trim() === "")) {
    return <span className="text-gray-400">{fallback}</span>;
  }

  if (!href) {
    return <span className={`break-words text-gray-900 ${className}`.trim()}>{label}</span>;
  }

  return (
    <button
      type="button"
      className={`text-left ${GRID_ORG_NAME_LINK_CLASS} ${className}`.trim()}
      onClick={(e) => {
        e.stopPropagation();
        onNavigate?.(href, e);
      }}
    >
      {label}
    </button>
  );
}
